export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/upgrade/upgrade-license.controller.js